import { NgIf } from '@angular/common';
import { Component, DestroyRef, inject, Input, OnInit } from '@angular/core';

import { TranslocoService } from '@jsverse/transloco';

import {
  translateTrigger,
  translateWords,
  TranslocoRootModule,
} from '@eai-tdv/core/transloco';

import { IconComponent } from '@eai-tdv/shared/icon';

import { IUploadResourceItem } from '../../upload-resource.types';

@Component({
  imports: [NgIf, IconComponent, TranslocoRootModule],
  selector: 'tdv-upload-resource-progress-header',
  templateUrl: './upload-resource-progress-header.component.html',
  styleUrls: ['./upload-resource-progress-header.component.scss'],
})
export class UploadResourceProgressHeaderComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);

  @Input() public set items(list: Array<IUploadResourceItem>) {
    this.calculateProgress(list || []);
  }
  @Input() public isFullView?: boolean;

  public headerTitle1?: string;
  public headerTitle2?: string;
  public uploadsAmount?: number;
  public uploadsLeftAmount?: number;

  constructor(private translocoS: TranslocoService) {}

  ngOnInit(): void {
    this.initTranslation();
  }

  private calculateProgress(list: Array<IUploadResourceItem>): void {
    this.uploadsAmount = list.length;
    this.uploadsLeftAmount = list.filter(
      i => i.progressForUploadBlobWatcher.value !== 100 && !i.isCancelled,
    ).length;
  }

  private initTranslation(): void {
    translateTrigger(this.translocoS, this.destroyRef, () => {
      this.headerTitle1 = translateWords(
        ['common.out', 'common.of'],
        this.translocoS,
      );
      this.headerTitle2 = translateWords(
        ['common.files', 'common.left', 'common.to-upload'],
        this.translocoS,
      );
    });
  }
}
